import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { ProjectCMSWidgetType, SpecificActionSubType } from 'htv-lib'
import { StateService } from './state.service'

@Injectable({
  providedIn: 'root',
})
export class WidgetActionService {
  messageWidgetAction$ = new Subject<SpecificActionSubType>()
  billWidgetAction$ = new Subject<SpecificActionSubType>()
  alarmRingingWidgetAction$ = new Subject<SpecificActionSubType>()
  wakeUpAlarmWidgetAction$ = new Subject<SpecificActionSubType>()

  constructor(private stateService: StateService) {
    // do nothing
  }

  dispatchAction(subType: SpecificActionSubType): boolean {
    const showingWidgets = this.stateService.showingWidgets$.value
    console.log('[WidgetActionService] dispatchAction called:', subType, 'showingWidgets:', Array.from(showingWidgets))

    switch (subType) {
      case SpecificActionSubType.DELETE_MESSAGE:
        if (showingWidgets.has(ProjectCMSWidgetType.MARRIOTT_PMS_MESSAGES)) {
          this.messageWidgetAction$.next(subType)
          return true
        }
        break

      case SpecificActionSubType.BILL_NEXT_PAGE:
      case SpecificActionSubType.BILL_PREVIOUS_PAGE:
      case SpecificActionSubType.BILL_EXPRESS_CHECKOUT:
        if (showingWidgets.has(ProjectCMSWidgetType.MARRIOTT_VIEW_BILL)) {
          this.billWidgetAction$.next(subType)
          return true
        }
        break

      case SpecificActionSubType.ALARM_STOP:
      case SpecificActionSubType.ALARM_SNOOZE:
        if (showingWidgets.has(ProjectCMSWidgetType.MARRIOTT_ALARM_RINGING)) {
          this.alarmRingingWidgetAction$.next(subType)
          return true
        }
        break

      case SpecificActionSubType.ALARM_CREATE:
        console.log('[WidgetActionService] ALARM_CREATE case, checking if MARRIOTT_WAKE_UP_ALARM is showing')
        if (showingWidgets.has(ProjectCMSWidgetType.MARRIOTT_WAKE_UP_ALARM)) {
          console.log('[WidgetActionService] MARRIOTT_WAKE_UP_ALARM is showing, dispatching action')
          this.wakeUpAlarmWidgetAction$.next(subType)
          return true
        } else {
          console.log('[WidgetActionService] MARRIOTT_WAKE_UP_ALARM is NOT showing')
        }
        break
    }

    return false
  }
}
